export const useLogout = () => {
  const logout = () => {
    // Create and submit form programmatically,
    // this method allows server-side redirection after logout.
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/logout";

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  return { logout };
};
